import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/sales/layout/layout';
import PresaleDetail from 'components/sales/leadDetails/presaleDetail/presaleDetail';
import PostsaleDetail from 'components/sales/leadDetails/postsaleDetail/postsaleLeadType';
import LeadDetail from 'components/sales/leadDetails/createLeadDetail/leadDetail';
import localization from 'assets/localization/localization';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import Notfound from 'pages/notfound';

const ViewLead = ({ viewDetails, getDetails, match, contractInvoicePreview }) => {
  const { baseUrl } = useContext(BaseUrl);
  const [details, setDetails] = useState(null);
  const [leadId, setleadId] = useState();
  const [siteId, setsiteId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isRender, setIsRender] = useState(false);

  useEffect(() => {
    (async () => {
      if (localStorage.getItem('viewDetail') !== 'undefined') {
        const leadTypeId =
          (await JSON.parse(localStorage.getItem('viewDetail'))) &&
          JSON.parse(localStorage.getItem('viewDetail'))[0].lead_type_id;
        const requestData = {
          lead_id: leadId,
          site_id: siteId,
          lead_type: leadTypeId,
        };
        if (leadId) {
          setIsLoading(true);
          const res = await getDetails(requestData);
          if (res === null || res === '') {
            setIsRender(true);
          }
          setIsLoading(false);
        }
      }
    })();
  }, [getDetails, leadId,siteId]);

  useEffect(() => {
    if (viewDetails) {
      setDetails(viewDetails);
    }
    setleadId(match.params.manageId ? match.params.manageId : match.params.id);
    setsiteId(match.params.manageId ? match.params.id : null);
  }, [viewDetails, match.params]);

  return isRender ? (
    <Notfound />
  ) : (
    <Layout
      title={localization.BacktoList}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/site-listing`}
    >
      {details?.lead_data && Object.keys(details?.lead_data).length > 0 && (
        <LeadDetail details={details} />
      )}
      {details?.lead_data &&
        Object.keys(details?.lead_data).length > 0  && (
          <>
            {/* {details?.presale_data &&
              Object.keys(details?.presale_data).length > 0 && (
                <PresaleDetail details={details.presale_data} />
              )} */}

            {details?.postsale_data &&
              Object.keys(details?.postsale_data).length > 0 && (
                <PostsaleDetail 
                  details={details.postsale_data}
                  contractInvoicePreview={contractInvoicePreview}
                  setIsLoading={setIsLoading}
                />
              )}
          </>
        )}

      {/* {details?.lead_data &&
        Object.keys(details?.lead_data).length > 0 &&
        details?.lead_data?.site_information_feature_key && (
          <>
            {details?.presale_data &&
              Object.keys(details?.presale_data).length > 0 && (
                <PresaleDetail details={details.presale_data} />
              )}

            {details?.postsale_data &&
              Object.keys(details?.postsale_data).length > 0 && (
                <PostsaleDetail details={details.postsale_data} />
              )}
          </>
        )} */}
    </Layout>
  );
};

ViewLead.propTypes = {
  viewDetails: PropTypes.any,
  getDetails: PropTypes.func,
  match: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  contractInvoicePreview: PropTypes.func,
};

export default ViewLead;
